import _extends from "@babel/runtime/helpers/extends";
import { COLOR } from "@xe/constants";
var lightMode = {
  button: {
    primary: {
      solid: COLOR.blue9,
      hollow: COLOR.blue10
    },
    danger: {
      solid: COLOR.red2,
      hollow: COLOR.red2
    }
  }
};
var darkMode = {
  button: _extends({}, lightMode.button, {
    primary: _extends({}, lightMode.button.primary, {
      hollow: COLOR.blue11
    })
  })
};
export default {
  darkMode: darkMode,
  lightMode: lightMode
};